/**
 * Formats a number as currency (USD)
 * @param value - The number to format
 * @param options - Optional formatting options
 * @returns Formatted currency string (without the $ symbol)
 */
export function formatCurrency(
	value: number,
	options?: {
		/** Force decimal places even for whole numbers */
		forceDecimals?: boolean;
	}
): string {
	const hasCents = value % 1 !== 0;
	const showDecimals = hasCents || options?.forceDecimals;

	return value.toLocaleString('en-US', {
		maximumFractionDigits: showDecimals ? 2 : 0,
		minimumFractionDigits: showDecimals ? 2 : 0,
	});
}
